import React, { useState } from "react";
import { Copy, Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import "./Hero.css";

const Hero = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText("git clone https://github.com/boltzmannlabs/Agent-Scientist.git");
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };

  return (
    <section className="cb-hero-section" id="home">
      <div className="cb-hero-ambient-wrap">
        <div className="cb-hermes-mesh cb-mesh-blue"></div>
        <div className="cb-hermes-mesh cb-mesh-cyan"></div>
      </div>

      <div className="container position-relative">
        <div className="cb-hero-content">

          <div className="cb-hero-title-wrap">
            <div className="cb-hero-title-halo" aria-hidden="true"></div>
            <h1 className="cb-hero-title">
              CHEMBIOAI
            </h1>
          </div>

          <p className="cb-hero-subtitle">
            Pioneering Open Source Research in <span className="cb-hero-gradient-text">AI and Life Sciences</span>
          </p>

          <p className="cb-hero-description">
            ChembioAI is a dynamic research open source community,
            committed to advancing scientific frontiers by seamlessly
            blending the realms of Chemistry, Biology, and Artificial
            Intelligence.
          </p>

          <div className="cb-hero-cta-group">
            <div className={`cb-hero-terminal-pill ${copied ? "is-copied" : ""}`}>
              <div
                className="cb-term-command"
                onClick={handleCopy}
                title="Click to copy git clone command"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") handleCopy();
                }}
              >
                <span className="cb-term-prompt">$</span>
                <span className="cb-term-code">git clone https://github.com/boltzmannlabs/Agent-Scientist</span>
              </div>
              
              <div className="cb-term-actions">
                <button
                  type="button"
                  className="cb-term-copy-action"
                  onClick={handleCopy}
                  title="Copy git clone command"
                  aria-label="Copy git clone command"
                >
                  {copied ? (
                    <>
                      <Check size={13} strokeWidth={2.8} className="cb-copy-check" />
                      <span className="cb-copy-text copied">Copied!</span>
                    </>
                  ) : (
                    <>
                      <Copy size={12} strokeWidth={2.2} className="cb-copy-icon" />
                      <span className="cb-copy-text">Copy</span>
                    </>
                  )}
                </button>

                <Link
                  to="/agent-scientist"
                  className="cb-term-explore-action"
                  title="Explore Agent Scientist Documentation"
                >
                  <span>Explore</span>
                  <ArrowRight size={13} strokeWidth={2.4} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
